import React from 'react';
import loadable from '@loadable/component';

const AmenitiesFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "AmenitiesFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/AmenitiesFilter/component'
    ),
);

class LoadableAmenitiesFilter extends React.Component {
  render() {
    return <AmenitiesFilter {...this.props} />;
  }
}

export default LoadableAmenitiesFilter;
